<template>
    <div class="ActivityGoodsList bgc box-shadow">
        <div class="eventinfo">
            <img class="img" :src="item.coveratturlid" alt="">
            <div>
                <div class="title">{{item.title}}</div>
                <div>
                    <span :class="'type '+resulttype(item.resulttype)">{{item.resulttypename}}</span>
                    <span :class="'type '+eventstatus(item.eventstatus)"
                          v-if="hostroletype==2">{{item.eventstatusname}}</span>
                </div>
            </div>
        </div>
        <div class="filters">
            <div class="add">
                <el-dropdown v-if="[30,100].indexOf(item.eventstatus)<0">
                <span class="el-dropdown-link">
                    <el-button type="primary">添加商品 <i class="el-icon-arrow-down"></i></el-button>
                </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="handleAddFromBack">从商品库添加</el-dropdown-item>
                        <el-dropdown-item @click.native="handleAdd">直接添加商品</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!--<el-button type="primary" v-if="[30,100].indexOf(item.eventstatus)<0" @click="handleAddFromBack">从商品库添加</el-button>-->
                <!--<el-button type="success" v-if="[30,100].indexOf(item.eventstatus)<0" @click="handleAdd">直接添加商品</el-button>-->
                <el-button type="warning" v-if="[30,100].indexOf(item.eventstatus)<0 && hostroletype==2"
                           @click="handleEditCateSort" style="margin-left: 20px">调整分类顺序
                </el-button>
                <el-button type="danger" v-if="[30,100].indexOf(item.eventstatus)<0 && hostroletype==2"
                           @click="handleActivityGoodsEditDialog">快捷设置
                </el-button>
            </div>
            <div class="search">
                <el-input v-model="param.productname" placeholder="请输入商品名称" class="condition" clearable></el-input>
                <el-input v-model="param.catename" placeholder="请输入商品分类" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="list bgc">
            <div class="result-list btn-operate-list bgc">
                <div class="tableData">
                    <div class="lengdeList box">
                        <span class="lengdeName blod innerbox imageTextBox">商品名称</span>
                        <span class="lengdeName blod innerbox">规格</span>
                        <span class="lengdeName blod innerbox">分类名称</span>
                        <span class="lengdeName blod innerbox">销售价格（元）</span>
                        <span class="lengdeName blod innerbox">商品库存</span>
                        <span class="lengdeName blod innerbox">商品佣金</span>
                        <span class="lengdeName blod innerbox">商品销量</span>
                        <span class="lengdeName blod innerbox" style="text-align: center !important;">排序</span>
                        <span class="lengdeName blod innerbox btn-operate tr">操作</span>
                    </div>
                    <div v-for="(obj,index) in tableData" :key="index">
                        <div class="box outbox">
                        <span class="innerbox imageTextBox">
                            <div class="nameBox">
                                <img class="img" v-lazy="obj.coveratturlid" :alt="obj.productname"
                                preview="videoList"/>
                                <div class="imageText-summary">
                                    <div class="textBox text-ellipses">
                                        <div class="text">{{obj.productname}}</div>
                                    </div>
                                    <div class="tc-blue openbtn" @click="handleOpen(obj)" v-if="obj.zproductlist.length">
                                        <span>多规格商品{{obj.isopen?'收起':'展开'}}</span>
                                        <i class="icon el-icon-arrow-up" v-if="obj.isopen"></i>
                                        <i class="icon el-icon-arrow-down" v-else></i>
                                    </div>
                                </div>
                            </div>
                        </span>
                            <span class="innerbox">{{obj.specs}}</span>
                            <span class="innerbox">{{obj.catename}}</span>
                            <span class="innerbox">{{obj.saleprice}}</span>
                            <span class="innerbox">{{obj.stockcount}}</span>
                            <span class="innerbox">{{obj.brokeragerate}}</span>
                            <span class="innerbox">{{obj.totalsalecount}}</span>
                            <span class="innerbox">
                            <span class="separator-btn upordown">
                                <div class="icon_bb_arrow" :class="[index==0?'prohibit':'']"
                                     v-if="[30,100].indexOf(item.eventstatus)<0">
                                    <i @click.stop="handleUp(obj, index, 1, 0)" class="icon icon_bb_arrow_up"></i>
                                </div>
                                <div class="icon_bb_arrow" :class="[index==(tableData.length-1)?'prohibit':'']"
                                     v-if="[30,100].indexOf(item.eventstatus)<0">
                                    <i @click.stop="handleDown(obj, index, 1, 0)" class="icon icon_bb_arrow_down"></i>
                                </div>
                            </span>
                        </span>
                            <span class="innerbox btn-operate">
                            <div class="tr">
                                <span class="separator-btn"
                                      v-if="hostroletype==2 && [30,100].indexOf(item.eventstatus)<0">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            <el-button type="text" size="small">添加规格</el-button>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="handleAdd2(obj)">直接添加商品</el-dropdown-item>
                                            <el-dropdown-item
                                                @click.native="handleAddFromBack2(obj)">从商品库添加</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </span>
                                <span class="separator-btn">
                                    <el-dropdown>
                                        <span class="el-dropdown-link">
                                            <el-button type="text" size="small">更多操作</el-button>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="handleCopy(obj)"
                                                              v-if="[30,100].indexOf(item.eventstatus)<0">复制商品</el-dropdown-item>
                                            <el-dropdown-item @click.native="handleEdit(obj)"
                                                              v-if="[30,100].indexOf(item.eventstatus)<0">编辑商品</el-dropdown-item>
                                            <el-dropdown-item @click.native="handleView(obj)"
                                                              v-if="[30,100].indexOf(item.eventstatus)>-1">查看商品</el-dropdown-item>
                                            <el-dropdown-item @click.native="handleDel(obj)"
                                                              v-if="[30,100].indexOf(item.eventstatus)<0">删除商品</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </span>
                            </div>
                        </span>
                        </div>
                        <transition name="slide-sort">
                            <div class="contentBox" v-if="obj.zproductlist.length && obj.isopen">
                                <div class="box" v-for="(obj2,idx) in obj.zproductlist" :key="idx">
                        <span class="innerbox imageTextBox">
                            <div class="nameBox">
                                    <img class="img" v-lazy="obj2.coveratturlid" :alt="obj2.productname"
                                         preview="videoList"/>
                                <div class="imageText-summary">
                                    <div class="textBox text-ellipses">
                                                <div class="text">{{obj2.productname}}</div>
                                            </div>
                                </div>
                            </div>
                        </span>
                                    <span class="innerbox">{{obj2.specs}}</span>
                                    <span class="innerbox">{{obj2.catename}}</span>
                                    <span class="innerbox">{{obj2.saleprice}}</span>
                                    <span class="innerbox">{{obj2.stockcount}}</span>
                                    <span class="innerbox">{{obj2.brokeragerate}}</span>
                                    <span class="innerbox">{{obj2.totalsalecount}}</span>
                                    <span class="innerbox">
                                    <span class="separator-btn upordown">
                                        <!--<div class="icon_bb_arrow" :class="[idx==0?'prohibit':'']">-->
                                        <!--<i @click.stop="handleUp(obj2, index, 2, idx)" class="icon icon_bb_arrow_up"></i>-->
                                        <!--</div>-->
                                        <!--<div class="icon_bb_arrow":class="[idx==(obj.zproductlist.length-1)?'prohibit':'']">-->
                                        <!--<i  @click.stop="handleDown(obj2, index, 2, idx)" class="icon icon_bb_arrow_down"></i>-->
                                        <!--</div>-->
                                    </span>
                            </span>
                                    <span class="innerbox btn-operate">
                            <div class="tr">
                                <span class="separator-btn">
                                    <el-button @click="handleCopy2(obj, obj2)" type="text" size="small">复制</el-button>
                                </span>
                                <span class="separator-btn">
                                    <el-button @click="handleEdit(obj2)" type="text" size="small">编辑</el-button>
                                </span>
                                <span class="separator-btn">
                                    <el-button @click="handleDel(obj2)" v-if="[30,100].indexOf(item.eventstatus)<0" type="text" size="small">删除</el-button>
                                </span>
                                <span class="separator-btn" v-if="!item.isopenevent && [30,100].indexOf(item.eventstatus)<0">
                                    <el-button @click="handleDisassociate(obj2)" type="text" size="small">取消关联</el-button>
                                </span>
                            </div>
                        </span>
                                </div>
                            </div>
                        </transition>

                    </div>
                </div>
                <div class="page" style="margin-top: 15px; text-align: center">
                    <el-pagination
                        background
                        @current-change="handleSizeChange"
                        :current-page.sync="page.page"
                        :page-size="page.pageSize"
                        :pager-count="11"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <goodsListDialog ref="goodsListDialog" @getList="refresh" @getList2="refresh"></goodsListDialog>
        <editCateSortDialog ref="editCateSortDialog" @getList="refresh"></editCateSortDialog>
        <activityGoodsEditDialog ref="activityGoodsEditDialog" @getList="refresh"></activityGoodsEditDialog>
    </div>
</template>

<script>

    import {
        getProductinfoList,
        uploadDeleteProductByEvent,
        getProviderProductinfoList,
        uploadProviderDeleteProductByEvent,
        cancelProductSpecsRelInfo,
        uploadEventProductIndex,
        uploadProviderEventProductIndex
    } from 'api/brandBusiness'
    import {mapGetters, mapActions} from 'vuex'
    import {brandBusiness} from 'api/enumCode'
    import GoodsListDialog from 'views/brandBusiness/activityMgt/activity/components/goodsListDialog.vue'
    import EditCateSortDialog from 'views/brandBusiness/activityMgt/activity/components/editCateSortDialog.vue'
    import ActivityGoodsEditDialog
        from 'views/brandBusiness/activityMgt/activity/components/activityGoodsEditDialog.vue'

    export default {
        name: 'BBActivityGoodsList',
        data() {
            return {
                param: {
                    catename: '',
                    eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                    productname: '',
                    status: ''
                },
                item: {},
                page: {
                    page: 1,
                    pageSize: 10,
                    pageCount: 0
                },
                tableData: [],
                total: 0,
                hostroletype: this.$route.query.hostroletype ? this.$route.query.hostroletype : 2 // 2 品牌商  4 服务商
            }
        },
        mounted() {
            if (!this.isRefresh) {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._getList()
                } else {
                    this._getProviderProductinfoList()
                }
            }
        },
        activated() {
            if (this.isRefresh) {
                if (this.isRefresh === 2) {
                    this.param = {
                        catename: '',
                        eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                        productname: '',
                        status: ''
                    }
                    this.page.page = 1
                }
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._getList()
                } else {
                    this._getProviderProductinfoList()
                }
                this.setIsRefresh(0)
            }
        },
        methods: {
            handleOpen(obj) {
                obj.isopen = !obj.isopen
            },
            handleActivityGoodsEditDialog() {
                this.$refs.activityGoodsEditDialog.openDialog(this.param)
            },
            handleDisassociate(obj) {
                let item = {
                    eventid: this.param.eventid,
                    productid: obj.productid
                }
                this._disassociate(item)
            },
            handleEditCateSort() {
                this.$refs.editCateSortDialog.openDialog(this.param)
            },
            handleView(row) {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this.$router.push({
                        name: 'BBActivityGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            iscopy: 0,
                            isview: 1
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'SPActivityTempGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            iscopy: 0,
                            isview: 1
                        }
                    })
                }
            },
            handleCopy(row) {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this.$router.push({
                        name: 'BBActivityGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            iscopy: 1
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'SPActivityTempGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            iscopy: 1
                        }
                    })
                }
            },
            handleCopy2(obj, row) {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this.$router.push({
                        name: 'BBActivityGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            specproductid: obj.productid,
                            iscopy: 1
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'SPActivityTempGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            specproductid: obj.productid,
                            iscopy: 1
                        }
                    })
                }
            },
            handleUp(obj, index, type, idx) {
                if ((type == 1 && index == 0) || (type == 2 && idx == 0)) return false
                let item = {
                    catetype: -1, // 上移-1 下移1
                    eventid: this.param.eventid,
                    productid: obj.productid
                }
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._uploadEventProductIndex(item, obj, index, type, idx)
                } else {
                    this._uploadEventProductIndex2(item, obj, index, type, idx)
                }
            },
            handleDown(obj, index, type, idx) {
                if ((type == 1 && index == this.tableData.length - 1) || (type == 2 && idx == this.tableData[index].zproductlist.length - 1)) return false
                let item = {
                    catetype: 1, // 上移-1 下移1
                    eventid: this.param.eventid,
                    productid: obj.productid
                }
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._uploadEventProductIndex(item, obj, index, type, idx)
                } else {
                    this._uploadEventProductIndex2(item, obj, index, type, idx)
                }
            },
            refresh() {
                this.param = {
                    catename: '',
                    eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                    productname: '',
                    status: ''
                }
                this.page.page = 1
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._getList()
                } else {
                    this._getProviderProductinfoList()
                }
                this.setIsRefresh(0)
            },
            handleAddFromBack() {
                this.$refs.goodsListDialog.openDialog(this.param, this.hostroletype, '')
            },
            handleAddFromBack2(obj) {
                this.$refs.goodsListDialog.openDialog(this.param, this.hostroletype, obj.productid)
            },
            handleSizeChange() {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._getList()
                } else {
                    this._getProviderProductinfoList()
                }
            },
            handleAdd() {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this.$router.push({
                        name: 'BBActivityGoodsEdit',
                        query: {
                            fromSource: 2,
                            eventid: this.param.eventid,
                            hostroletype: this.hostroletype,
                            specproductid: '',
                            iscopy: 0
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'SPActivityTempGoodsEdit',
                        query: {
                            fromSource: 2,
                            eventid: this.param.eventid,
                            hostroletype: this.hostroletype,
                            specproductid: '',
                            iscopy: 0
                        }
                    })
                }
            },
            handleAdd2(obj) {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this.$router.push({
                        name: 'BBActivityGoodsEdit',
                        query: {
                            fromSource: 2,
                            eventid: this.param.eventid,
                            hostroletype: this.hostroletype,
                            specproductid: obj.productid
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'SPActivityTempGoodsEdit',
                        query: {
                            fromSource: 2,
                            eventid: this.param.eventid,
                            hostroletype: this.hostroletype,
                            specproductid: obj.productid
                        }
                    })
                }
            },
            handleQuery() {
                this.page.page = 1
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._getList()
                } else {
                    this._getProviderProductinfoList()
                }
            },
            handleEdit(row) {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this.$router.push({
                        name: 'BBActivityGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            iscopy: 0
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'SPActivityTempGoodsEdit',
                        query: {
                            productid: row.productid,
                            fromSource: 2,
                            eventid: this.param.eventid,
                            eventstatus: this.item.eventstatus,
                            hostroletype: this.hostroletype,
                            isopenevent: this.item.isopenevent,
                            iscopy: 0
                        }
                    })
                }
            },
            handleDel(row) {
                this.$confirm('确认删除该商品', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    let obj = {
                        productid: row.productid,
                        eventid: this.param.eventid
                    }
                    if (this.hostroletype === 2 || this.hostroletype === '2') {
                        this._del(obj)
                    } else {
                        this._deleteProviderEventProductInfo(obj)
                    }
                })
            },
            _uploadEventProductIndex(item, obj, index, type, idx) {
                this.setLoading(true)
                uploadEventProductIndex({
                    data: item,
                    success: data => {
                        this.$message.success('修改顺序成功')
                        this.setLoading(false)
                        if (item.catetype == -1) {
                            if (type == 1) {
                                this.tableData.splice(index, 1)
                                this.tableData.splice(index - 1, 0, obj)
                            } else {
                                this.tableData[index].zproductlist.splice(idx, 1)
                                this.tableData[index].zproductlist.splice(idx - 1, 0, obj)
                            }

                        } else {
                            if (type == 1) {
                                this.tableData.splice(index, 1)
                                this.tableData.splice(index + 1, 0, obj)
                            } else {
                                this.tableData[index].zproductlist.splice(idx, 1)
                                this.tableData[index].zproductlist.splice(idx + 1, 0, obj)
                            }
                        }
                        // this._getList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            _uploadEventProductIndex2(item, obj, index, type, idx) {
                this.setLoading(true)
                uploadProviderEventProductIndex({
                    data: item,
                    success: data => {
                        this.$message.success('修改顺序成功')
                        this.setLoading(false)
                        if (item.catetype == -1) {
                            if (type == 1) {
                                this.tableData.splice(index, 1)
                                this.tableData.splice(index - 1, 0, obj)
                            } else {
                                this.tableData[index].zproductlist.splice(idx, 1)
                                this.tableData[index].zproductlist.splice(idx - 1, 0, obj)
                            }

                        } else {
                            if (type == 1) {
                                this.tableData.splice(index, 1)
                                this.tableData.splice(index + 1, 0, obj)
                            } else {
                                this.tableData[index].zproductlist.splice(idx, 1)
                                this.tableData[index].zproductlist.splice(idx + 1, 0, obj)
                            }
                        }
                        // this._getList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            _disassociate(obj) {
                this.setLoading(true)
                cancelProductSpecsRelInfo({
                    data: obj,
                    success: data => {
                        this.$message.success('取消关联成功')
                        this.setLoading(false)
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            _del(obj) {
                this.setLoading(true)
                uploadDeleteProductByEvent({
                    data: obj,
                    success: data => {
                        this.$message.success('删除成功')
                        this.setLoading(false)
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            _deleteProviderEventProductInfo(obj) {
                this.setLoading(true)
                uploadProviderDeleteProductByEvent({
                    data: obj,
                    success: data => {
                        this.$message.success('删除成功')
                        this.setLoading(false)
                        this._getProviderProductinfoList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            _getList() {
                this.setLoading(true)
                getProductinfoList({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        data.data.productlist.forEach(obj => {
                            obj.isopen = true
                        })
                        if (this.page.page == 1) {
                            this.item = data.data.eventinfo
                        }
                        this.tableData = data.data.productlist
                        this.total = data.data.pageinfo.rowCount
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            _getProviderProductinfoList() {
                this.setLoading(true)
                getProviderProductinfoList({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        data.data.productlist.forEach(obj => {
                            obj.isopen = true
                        })
                        if (this.page.page == 1) {
                            this.item = data.data.eventinfo
                        }
                        this.tableData = data.data.productlist
                        this.total = data.data.pageinfo.rowCount
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading', 'setIsRefresh'
            ])
        },
        filters: {},
        watch: {},
        computed: {
            resulttype() {
                return function (value) {
                    for (let i = 0; i < brandBusiness.resulttype.length; i++) {
                        if (value === brandBusiness.resulttype[i].code) {
                            return brandBusiness.resulttype[i].cls
                        }
                    }
                    return value
                }
            },
            eventstatus() {
                return function (value) {
                    for (let i = 0; i < brandBusiness.eventstatus.length; i++) {
                        if (value === brandBusiness.eventstatus[i].code) {
                            return brandBusiness.eventstatus[i].cls
                        }
                    }
                    return value
                }
            },
            ...mapGetters(['isRefresh'])
        },
        components: {
            GoodsListDialog, EditCateSortDialog, ActivityGoodsEditDialog
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/index";

    .ActivityGoodsList {
        background: #fff;
        padding: 20px;
        .filters input{
            width: 180px !important;
        }
        .eventinfo {
            display: flex;
            background: #FAFAFA;
            padding: 20px;
            margin-bottom: 30px;
            .img {
                width: 180px;
                height: 102px;
                margin-right: 30px;
            }
            .title {
                margin-bottom: 10px;
            }
            .type {
                margin-right: 20px;
            }
        }
        .nameBox {
            align-items: flex-start !important;
            display: flex;
            .img {
                min-width: 60px;
                width: 60px;
                height: 60px;
                margin-right: 16px;
                flex-shrink: 0;
                flex-grow: 0;
            }
            .imageText-summary {
                height: 60px;
                padding: 0 6px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                text-align: left;
                min-width: 104px;
                .openbtn {
                    font-size: 12px;
                }
                .icon {
                    margin-left: 6px;
                }
            }
        }
        .list {
            margin-top: 20px;
            .box {
                display: flex;
                overflow: hidden;
                padding: 12px;
                .innerbox {
                    width: 11%;
                    text-align: center;
                    box-sizing: border-box;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            .lengdeList {
                padding: 0;
                .innerbox {
                    padding: 0 12px;
                    height: 48px;
                    box-sizing: border-box;
                }
            }
            .imageTextBox {
                justify-content: flex-start !important;
                width: 20% !important;
                min-width: 200px;
            }
            .btn-operate {
                justify-content: flex-end !important;
                width: 15% !important;
                min-width: 175px;
                text-align: right !important;
            }
            .outbox {
                border-top: 1px solid $line;
            }
            .contentBox {
                background: #F6F8FB;
                border-top: 1px solid $line;
                /*.box{*/
                /*padding-left: 36px !important;*/
                /*}*/
            }
            .box:hover {
                background: #E6F1FC;
                .text-ellipses{
                    &:after{
                        background: #E6F1FC;
                    }
                }
            }
            .tableData {
                border: 1px solid $line;
            }
            .lengdeList {
                background: #FAFAFA;
                border-top: 0px solid $line;
            }
        }
        .upordown {
            display: flex;
            justify-content: center;
            align-items: center;
            .icon_bb_arrow {
                margin-left: 20px;
                width: 20px;
                height: 20px;
                .icon {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .slide-sort-enter-active, .slide-sort-leave-active {
            transition: all 0.3s
        }
        .slide-sort-enter, .slide-sort-leave-to {
            /*transform: translate3d(0, 100%, 0)*/
        }
        .contentBox{
            .text-ellipses{
                &:after{
                    background: #F6F8FB;
                }
            }
        }
    }
</style>
